import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/renthouse/rhFeeBack/page', data, {
    trim: true
  })
}
